import React from 'react';
import {UseMachineType} from '@practicegenius/register-account/src/machines/useAccountRegistrationMachineType';
import {RegistrationEvent} from '@practicegenius/register-account/src/machines/accountRegistration';
import {useQueryParams} from '../../../utils/custom-hooks';

type Props = {
  registrationMachine: UseMachineType;
};

export const GateKeepUserWithoutToken: React.FCC<Props> = props => {
  const [
    {
      context: {token, linkedPractice},
    },
    send,
  ] = props.registrationMachine;

  const {
    token: queryParamToken,
    unregisteredInput,
    inviteCode,
  } = useQueryParams();

  const hasAllowedQueryParams = Boolean(
    queryParamToken || token || unregisteredInput || inviteCode
  );
  const hasLinkedPractice = Boolean(linkedPractice);

  const hasRequirements = hasAllowedQueryParams || hasLinkedPractice;

  React.useEffect(() => {
    if (!hasRequirements) send(RegistrationEvent.RESTART);
  }, [hasRequirements, send]);

  return <>{hasRequirements ? props.children : null}</>;
};
